import { useRouter } from 'next/router';
import type { CustomEventData, EventName } from './types';
import { track } from './public-track';

export const useAnalytics = () => {
  const router = useRouter();

  const trackAndNavigate = (
    eventName: EventName,
    pathToNavigate: string,
    customDate?: CustomEventData,
  ) => {
    track(eventName, customDate);

    setTimeout(() => {
      void router.push(pathToNavigate);
    }, 750);
  };

  return {
    trackAndNavigate,
  };
};
